import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { JIRA_PROJECT_FIELDS } from '@elementary/common-ui/constants/queryKeys';
import { useTicketingIntegration } from 'shared/hooks/integrations';
import { fetchProjectFields } from './api';

const useJiraProjectFields = (envId?: string, integrationId?: string) => {
  const { ticketingQuery } = useTicketingIntegration({ envId });

  const integrations = useMemo(() => {
    const enabledJira =
      ticketingQuery.data?.integrations.filter(
        (integration) => integration.enabled && integration.type === 'jira',
      ) ?? [];

    if (integrationId) {
      return enabledJira.filter(
        (integration) => integration.id === integrationId,
      );
    }

    return enabledJira;
  }, [ticketingQuery.data?.integrations, integrationId]);

  return useQueries({
    queries: integrations.map((integration) => ({
      queryKey: [
        JIRA_PROJECT_FIELDS,
        envId,
        integration.id,
        integration.project_id,
      ],
      queryFn: () =>
        fetchProjectFields(envId!, integration.id, integration.project_id),
      enabled: !!envId && !!integration.id && !!integration.project_id,
    })),
  });
};

export default useJiraProjectFields;
